/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { Interacts } from "../models/interacts";
import { InteractPoDPage } from "../models/interact-po-dpage";
import { UdPreFilteredInteractives } from "../models/ud-pre-filtered-interactives";
import { UdModInteractives } from "../models/ud-mod-interactives";
import { UdInteractFilters } from "../models/ud-interact-filters";
import { UdInteractBookmarks } from "../models/ud-interact-bookmarks";
import { SubInteractReportExports } from "../models/sub-interact-report-exports";
import { PreFilterKeys } from "../models/pre-filter-keys";
import { PartnerEmbed } from "../models/partner-embed";
import { UserLog } from "../models/user-log";
import { InteractSubContents } from "../models/interact-sub-contents";
import { InteractReports } from "../models/interact-reports";
import { UpdateInteractivePrintOnDemandPages } from "../models/update-interactive-print-on-demand-pages";
import { InteractReportsEx } from "../models/interact-reports-ex";
@Injectable({
  providedIn: "root",
})
class AdminInteractiveService extends __BaseService {
  static readonly adminInteractiveGetInteractivesPath =
    "/api/admin/interactive/AdminInteractive/GetInteractives";
  static readonly adminInteractiveGetInteractivePrintOnDemandPagesPath =
    "/api/admin/interactive/AdminInteractive/GetInteractivePrintOnDemandPages/{interactId}";
  static readonly adminInteractiveCreateInteractivePath =
    "/api/admin/interactive/AdminInteractive/CreateInteractive";
  static readonly adminInteractiveEditInteractivePath =
    "/api/admin/interactive/AdminInteractive/EditInteractive";
  static readonly adminInteractiveUpdateInteractivePrintOnDemandPagesPath =
    "/api/admin/interactive/AdminInteractive/UpdateInteractivePrintOnDemandPages";
  static readonly adminInteractiveDeleteInteractivePath =
    "/api/admin/interactive/AdminInteractive/DeleteInteractive";
  static readonly adminInteractiveGetInteractiveReportsPath =
    "/api/admin/interactive/AdminInteractive/GetInteractiveReports";
  static readonly adminInteractiveEditInteractiveReportPath =
    "/api/admin/interactive/AdminInteractive/EditInteractiveReport";
  static readonly adminInteractiveDeleteInteractiveReportPath =
    "/api/admin/interactive/AdminInteractive/DeleteInteractiveReport";
  static readonly adminInteractiveSendEmailNotificationsPath =
    "/api/admin/interactive/AdminInteractive/SendEmailNotifications";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminInteractiveGetInteractivesResponse(): __Observable<
    __StrictHttpResponse<Array<Interacts>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/interactive/AdminInteractive/GetInteractives`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Interacts>>;
      })
    );
  }
  adminInteractiveGetInteractives(): __Observable<Array<Interacts>> {
    return this.adminInteractiveGetInteractivesResponse().pipe(
      __map((_r) => _r.body as Array<Interacts>)
    );
  }

  /**
   * @param interactId undefined
   */
  adminInteractiveGetInteractivePrintOnDemandPagesResponse(
    interactId: number
  ): __Observable<__StrictHttpResponse<Array<InteractPoDPage>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/GetInteractivePrintOnDemandPages/${interactId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractPoDPage>>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  adminInteractiveGetInteractivePrintOnDemandPages(
    interactId: number
  ): __Observable<Array<InteractPoDPage>> {
    return this.adminInteractiveGetInteractivePrintOnDemandPagesResponse(
      interactId
    ).pipe(__map((_r) => _r.body as Array<InteractPoDPage>));
  }

  /**
   * @param params The `AdminInteractiveService.AdminInteractiveCreateInteractiveParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `interactive.UdPreFilteredInteractives`:
   *
   * - `interactive.UdModInteractives`:
   *
   * - `interactive.UdInteractFilters`:
   *
   * - `interactive.UdInteractBookemarks`:
   *
   * - `interactive.SubInteractReportExports`:
   *
   * - `interactive.ProductUrl`:
   *
   * - `interactive.PreFilterTitleAvailable`:
   *
   * - `interactive.PreFilterRegionAvailable`:
   *
   * - `interactive.PreFilterOccupationAvailable`:
   *
   * - `interactive.PreFilterKeys`:
   *
   * - `interactive.PreFilterIndustryAvailable`:
   *
   * - `interactive.PreFilterCompanyAvailable`:
   *
   * - `interactive.PowerBireportPublishDate`:
   *
   * - `interactive.PowerBireportId`:
   *
   * - `interactive.PowerBiobjectNames`:
   *
   * - `interactive.PowerBidatasetPublishDate`:
   *
   * - `interactive.PowerBidatasetId`:
   *
   * - `interactive.PartnerEmbeds`:
   *
   * - `interactive.MarketingUrl`:
   *
   * - `interactive.Logs`:
   *
   * - `interactive.InteractSubContents`:
   *
   * - `interactive.InteractReports`:
   *
   * - `interactive.InteractName`:
   *
   * - `interactive.InteractId`:
   *
   * - `interactive.FreeInteractiveUrl`:
   *
   * - `interactive.FreeInteractive`:
   *
   * - `interactive.FileName`:
   *
   * - `interactive.FileId`:
   *
   * - `interactive.Description`:
   *
   * - `interactive.CanPreFilter`:
   *
   * - `interactive.CanModify`:
   */
  adminInteractiveCreateInteractiveResponse(
    params: AdminInteractiveService.AdminInteractiveCreateInteractiveParams
  ): __Observable<__StrictHttpResponse<Interacts>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.upload != null) {
      __formData.append("upload", params.upload as string | Blob);
    }
    (params.interactiveUdPreFilteredInteractives || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.UdPreFilteredInteractives",
          JSON.stringify(val)
        );
    });
    (params.interactiveUdModInteractives || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.UdModInteractives", JSON.stringify(val));
    });
    (params.interactiveUdInteractFilters || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.UdInteractFilters", JSON.stringify(val));
    });
    (params.interactiveUdInteractBookemarks || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.UdInteractBookemarks",
          JSON.stringify(val)
        );
    });
    (params.interactiveSubInteractReportExports || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.SubInteractReportExports",
          JSON.stringify(val)
        );
    });
    if (params.interactiveProductUrl != null) {
      __formData.append(
        "interactive.ProductUrl",
        params.interactiveProductUrl as string | Blob
      );
    }
    if (params.interactivePreFilterTitleAvailable != null) {
      __formData.append(
        "interactive.PreFilterTitleAvailable",
        JSON.stringify(params.interactivePreFilterTitleAvailable)
      );
    }
    if (params.interactivePreFilterRegionAvailable != null) {
      __formData.append(
        "interactive.PreFilterRegionAvailable",
        JSON.stringify(params.interactivePreFilterRegionAvailable)
      );
    }
    if (params.interactivePreFilterOccupationAvailable != null) {
      __formData.append(
        "interactive.PreFilterOccupationAvailable",
        JSON.stringify(params.interactivePreFilterOccupationAvailable)
      );
    }
    (params.interactivePreFilterKeys || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.PreFilterKeys", JSON.stringify(val));
    });
    if (params.interactivePreFilterIndustryAvailable != null) {
      __formData.append(
        "interactive.PreFilterIndustryAvailable",
        JSON.stringify(params.interactivePreFilterIndustryAvailable)
      );
    }
    if (params.interactivePreFilterCompanyAvailable != null) {
      __formData.append(
        "interactive.PreFilterCompanyAvailable",
        JSON.stringify(params.interactivePreFilterCompanyAvailable)
      );
    }
    if (params.interactivePowerBireportPublishDate != null) {
      __formData.append(
        "interactive.PowerBireportPublishDate",
        params.interactivePowerBireportPublishDate as string | Blob
      );
    }
    if (params.interactivePowerBireportId != null) {
      __formData.append(
        "interactive.PowerBireportId",
        params.interactivePowerBireportId as string | Blob
      );
    }
    if (params.interactivePowerBiobjectNames != null) {
      __formData.append(
        "interactive.PowerBiobjectNames",
        params.interactivePowerBiobjectNames as string | Blob
      );
    }
    if (params.interactivePowerBidatasetPublishDate != null) {
      __formData.append(
        "interactive.PowerBidatasetPublishDate",
        params.interactivePowerBidatasetPublishDate as string | Blob
      );
    }
    if (params.interactivePowerBidatasetId != null) {
      __formData.append(
        "interactive.PowerBidatasetId",
        params.interactivePowerBidatasetId as string | Blob
      );
    }
    (params.interactivePartnerEmbeds || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.PartnerEmbeds", JSON.stringify(val));
    });
    if (params.interactiveMarketingUrl != null) {
      __formData.append(
        "interactive.MarketingUrl",
        params.interactiveMarketingUrl as string | Blob
      );
    }
    (params.interactiveLogs || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.Logs", JSON.stringify(val));
    });
    (params.interactiveInteractSubContents || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.InteractSubContents",
          JSON.stringify(val)
        );
    });
    (params.interactiveInteractReports || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.InteractReports", JSON.stringify(val));
    });
    if (params.interactiveInteractName != null) {
      __formData.append(
        "interactive.InteractName",
        params.interactiveInteractName as string | Blob
      );
    }
    if (params.interactiveInteractId != null) {
      __formData.append(
        "interactive.InteractId",
        JSON.stringify(params.interactiveInteractId)
      );
    }
    if (params.interactiveFreeInteractiveUrl != null) {
      __formData.append(
        "interactive.FreeInteractiveUrl",
        params.interactiveFreeInteractiveUrl as string | Blob
      );
    }
    if (params.interactiveFreeInteractive != null) {
      __formData.append(
        "interactive.FreeInteractive",
        JSON.stringify(params.interactiveFreeInteractive)
      );
    }
    if (params.interactiveFileName != null) {
      __formData.append(
        "interactive.FileName",
        params.interactiveFileName as string | Blob
      );
    }
    if (params.interactiveFileId != null) {
      __formData.append(
        "interactive.FileId",
        params.interactiveFileId as string | Blob
      );
    }
    if (params.interactiveDescription != null) {
      __formData.append(
        "interactive.Description",
        params.interactiveDescription as string | Blob
      );
    }
    if (params.interactiveCanPreFilter != null) {
      __formData.append(
        "interactive.CanPreFilter",
        JSON.stringify(params.interactiveCanPreFilter)
      );
    }
    if (params.interactiveCanModify != null) {
      __formData.append(
        "interactive.CanModify",
        JSON.stringify(params.interactiveCanModify)
      );
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/CreateInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Interacts>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveService.AdminInteractiveCreateInteractiveParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `interactive.UdPreFilteredInteractives`:
   *
   * - `interactive.UdModInteractives`:
   *
   * - `interactive.UdInteractFilters`:
   *
   * - `interactive.UdInteractBookemarks`:
   *
   * - `interactive.SubInteractReportExports`:
   *
   * - `interactive.ProductUrl`:
   *
   * - `interactive.PreFilterTitleAvailable`:
   *
   * - `interactive.PreFilterRegionAvailable`:
   *
   * - `interactive.PreFilterOccupationAvailable`:
   *
   * - `interactive.PreFilterKeys`:
   *
   * - `interactive.PreFilterIndustryAvailable`:
   *
   * - `interactive.PreFilterCompanyAvailable`:
   *
   * - `interactive.PowerBireportPublishDate`:
   *
   * - `interactive.PowerBireportId`:
   *
   * - `interactive.PowerBiobjectNames`:
   *
   * - `interactive.PowerBidatasetPublishDate`:
   *
   * - `interactive.PowerBidatasetId`:
   *
   * - `interactive.PartnerEmbeds`:
   *
   * - `interactive.MarketingUrl`:
   *
   * - `interactive.Logs`:
   *
   * - `interactive.InteractSubContents`:
   *
   * - `interactive.InteractReports`:
   *
   * - `interactive.InteractName`:
   *
   * - `interactive.InteractId`:
   *
   * - `interactive.FreeInteractiveUrl`:
   *
   * - `interactive.FreeInteractive`:
   *
   * - `interactive.FileName`:
   *
   * - `interactive.FileId`:
   *
   * - `interactive.Description`:
   *
   * - `interactive.CanPreFilter`:
   *
   * - `interactive.CanModify`:
   */
  adminInteractiveCreateInteractive(
    params: AdminInteractiveService.AdminInteractiveCreateInteractiveParams
  ): __Observable<Interacts> {
    return this.adminInteractiveCreateInteractiveResponse(params).pipe(
      __map((_r) => _r.body as Interacts)
    );
  }

  /**
   * @param params The `AdminInteractiveService.AdminInteractiveEditInteractiveParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `interactive.UdPreFilteredInteractives`:
   *
   * - `interactive.UdModInteractives`:
   *
   * - `interactive.UdInteractFilters`:
   *
   * - `interactive.UdInteractBookemarks`:
   *
   * - `interactive.SubInteractReportExports`:
   *
   * - `interactive.ProductUrl`:
   *
   * - `interactive.PreFilterTitleAvailable`:
   *
   * - `interactive.PreFilterRegionAvailable`:
   *
   * - `interactive.PreFilterOccupationAvailable`:
   *
   * - `interactive.PreFilterKeys`:
   *
   * - `interactive.PreFilterIndustryAvailable`:
   *
   * - `interactive.PreFilterCompanyAvailable`:
   *
   * - `interactive.PowerBireportPublishDate`:
   *
   * - `interactive.PowerBireportId`:
   *
   * - `interactive.PowerBiobjectNames`:
   *
   * - `interactive.PowerBidatasetPublishDate`:
   *
   * - `interactive.PowerBidatasetId`:
   *
   * - `interactive.PartnerEmbeds`:
   *
   * - `interactive.MarketingUrl`:
   *
   * - `interactive.Logs`:
   *
   * - `interactive.InteractSubContents`:
   *
   * - `interactive.InteractReports`:
   *
   * - `interactive.InteractName`:
   *
   * - `interactive.InteractId`:
   *
   * - `interactive.FreeInteractiveUrl`:
   *
   * - `interactive.FreeInteractive`:
   *
   * - `interactive.FileName`:
   *
   * - `interactive.FileId`:
   *
   * - `interactive.Description`:
   *
   * - `interactive.CanPreFilter`:
   *
   * - `interactive.CanModify`:
   */
  adminInteractiveEditInteractiveResponse(
    params: AdminInteractiveService.AdminInteractiveEditInteractiveParams
  ): __Observable<__StrictHttpResponse<Interacts>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.upload != null) {
      __formData.append("upload", params.upload as string | Blob);
    }
    (params.interactiveUdPreFilteredInteractives || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.UdPreFilteredInteractives",
          JSON.stringify(val)
        );
    });
    (params.interactiveUdModInteractives || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.UdModInteractives", JSON.stringify(val));
    });
    (params.interactiveUdInteractFilters || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.UdInteractFilters", JSON.stringify(val));
    });
    (params.interactiveUdInteractBookemarks || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.UdInteractBookemarks",
          JSON.stringify(val)
        );
    });
    (params.interactiveSubInteractReportExports || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.SubInteractReportExports",
          JSON.stringify(val)
        );
    });
    if (params.interactiveProductUrl != null) {
      __formData.append(
        "interactive.ProductUrl",
        params.interactiveProductUrl as string | Blob
      );
    }
    if (params.interactivePreFilterTitleAvailable != null) {
      __formData.append(
        "interactive.PreFilterTitleAvailable",
        JSON.stringify(params.interactivePreFilterTitleAvailable)
      );
    }
    if (params.interactivePreFilterRegionAvailable != null) {
      __formData.append(
        "interactive.PreFilterRegionAvailable",
        JSON.stringify(params.interactivePreFilterRegionAvailable)
      );
    }
    if (params.interactivePreFilterOccupationAvailable != null) {
      __formData.append(
        "interactive.PreFilterOccupationAvailable",
        JSON.stringify(params.interactivePreFilterOccupationAvailable)
      );
    }
    (params.interactivePreFilterKeys || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.PreFilterKeys", JSON.stringify(val));
    });
    if (params.interactivePreFilterIndustryAvailable != null) {
      __formData.append(
        "interactive.PreFilterIndustryAvailable",
        JSON.stringify(params.interactivePreFilterIndustryAvailable)
      );
    }
    if (params.interactivePreFilterCompanyAvailable != null) {
      __formData.append(
        "interactive.PreFilterCompanyAvailable",
        JSON.stringify(params.interactivePreFilterCompanyAvailable)
      );
    }
    if (params.interactivePowerBireportPublishDate != null) {
      __formData.append(
        "interactive.PowerBireportPublishDate",
        params.interactivePowerBireportPublishDate as string | Blob
      );
    }
    if (params.interactivePowerBireportId != null) {
      __formData.append(
        "interactive.PowerBireportId",
        params.interactivePowerBireportId as string | Blob
      );
    }
    if (params.interactivePowerBiobjectNames != null) {
      __formData.append(
        "interactive.PowerBiobjectNames",
        params.interactivePowerBiobjectNames as string | Blob
      );
    }
    if (params.interactivePowerBidatasetPublishDate != null) {
      __formData.append(
        "interactive.PowerBidatasetPublishDate",
        params.interactivePowerBidatasetPublishDate as string | Blob
      );
    }
    if (params.interactivePowerBidatasetId != null) {
      __formData.append(
        "interactive.PowerBidatasetId",
        params.interactivePowerBidatasetId as string | Blob
      );
    }
    (params.interactivePartnerEmbeds || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.PartnerEmbeds", JSON.stringify(val));
    });
    if (params.interactiveMarketingUrl != null) {
      __formData.append(
        "interactive.MarketingUrl",
        params.interactiveMarketingUrl as string | Blob
      );
    }
    (params.interactiveLogs || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.Logs", JSON.stringify(val));
    });
    (params.interactiveInteractSubContents || []).forEach((val) => {
      if (val != null)
        __formData.append(
          "interactive.InteractSubContents",
          JSON.stringify(val)
        );
    });
    (params.interactiveInteractReports || []).forEach((val) => {
      if (val != null)
        __formData.append("interactive.InteractReports", JSON.stringify(val));
    });
    if (params.interactiveInteractName != null) {
      __formData.append(
        "interactive.InteractName",
        params.interactiveInteractName as string | Blob
      );
    }
    if (params.interactiveInteractId != null) {
      __formData.append(
        "interactive.InteractId",
        JSON.stringify(params.interactiveInteractId)
      );
    }
    if (params.interactiveFreeInteractiveUrl != null) {
      __formData.append(
        "interactive.FreeInteractiveUrl",
        params.interactiveFreeInteractiveUrl as string | Blob
      );
    }
    if (params.interactiveFreeInteractive != null) {
      __formData.append(
        "interactive.FreeInteractive",
        JSON.stringify(params.interactiveFreeInteractive)
      );
    }
    if (params.interactiveFileName != null) {
      __formData.append(
        "interactive.FileName",
        params.interactiveFileName as string | Blob
      );
    }
    if (params.interactiveFileId != null) {
      __formData.append(
        "interactive.FileId",
        params.interactiveFileId as string | Blob
      );
    }
    if (params.interactiveDescription != null) {
      __formData.append(
        "interactive.Description",
        params.interactiveDescription as string | Blob
      );
    }
    if (params.interactiveCanPreFilter != null) {
      __formData.append(
        "interactive.CanPreFilter",
        JSON.stringify(params.interactiveCanPreFilter)
      );
    }
    if (params.interactiveCanModify != null) {
      __formData.append(
        "interactive.CanModify",
        JSON.stringify(params.interactiveCanModify)
      );
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/interactive/AdminInteractive/EditInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Interacts>;
      })
    );
  }
  /**
   * @param params The `AdminInteractiveService.AdminInteractiveEditInteractiveParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `interactive.UdPreFilteredInteractives`:
   *
   * - `interactive.UdModInteractives`:
   *
   * - `interactive.UdInteractFilters`:
   *
   * - `interactive.UdInteractBookemarks`:
   *
   * - `interactive.SubInteractReportExports`:
   *
   * - `interactive.ProductUrl`:
   *
   * - `interactive.PreFilterTitleAvailable`:
   *
   * - `interactive.PreFilterRegionAvailable`:
   *
   * - `interactive.PreFilterOccupationAvailable`:
   *
   * - `interactive.PreFilterKeys`:
   *
   * - `interactive.PreFilterIndustryAvailable`:
   *
   * - `interactive.PreFilterCompanyAvailable`:
   *
   * - `interactive.PowerBireportPublishDate`:
   *
   * - `interactive.PowerBireportId`:
   *
   * - `interactive.PowerBiobjectNames`:
   *
   * - `interactive.PowerBidatasetPublishDate`:
   *
   * - `interactive.PowerBidatasetId`:
   *
   * - `interactive.PartnerEmbeds`:
   *
   * - `interactive.MarketingUrl`:
   *
   * - `interactive.Logs`:
   *
   * - `interactive.InteractSubContents`:
   *
   * - `interactive.InteractReports`:
   *
   * - `interactive.InteractName`:
   *
   * - `interactive.InteractId`:
   *
   * - `interactive.FreeInteractiveUrl`:
   *
   * - `interactive.FreeInteractive`:
   *
   * - `interactive.FileName`:
   *
   * - `interactive.FileId`:
   *
   * - `interactive.Description`:
   *
   * - `interactive.CanPreFilter`:
   *
   * - `interactive.CanModify`:
   */
  adminInteractiveEditInteractive(
    params: AdminInteractiveService.AdminInteractiveEditInteractiveParams
  ): __Observable<Interacts> {
    return this.adminInteractiveEditInteractiveResponse(params).pipe(
      __map((_r) => _r.body as Interacts)
    );
  }

  /**
   * @param request undefined
   */
  adminInteractiveUpdateInteractivePrintOnDemandPagesResponse(
    request: UpdateInteractivePrintOnDemandPages
  ): __Observable<__StrictHttpResponse<Array<InteractPoDPage>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/UpdateInteractivePrintOnDemandPages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractPoDPage>>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminInteractiveUpdateInteractivePrintOnDemandPages(
    request: UpdateInteractivePrintOnDemandPages
  ): __Observable<Array<InteractPoDPage>> {
    return this.adminInteractiveUpdateInteractivePrintOnDemandPagesResponse(
      request
    ).pipe(__map((_r) => _r.body as Array<InteractPoDPage>));
  }

  /**
   * @param interactId undefined
   */
  adminInteractiveDeleteInteractiveResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/DeleteInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  adminInteractiveDeleteInteractive(interactId?: number): __Observable<Blob> {
    return this.adminInteractiveDeleteInteractiveResponse(interactId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  adminInteractiveGetInteractiveReportsResponse(): __Observable<
    __StrictHttpResponse<Array<InteractReportsEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/GetInteractiveReports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InteractReportsEx>>;
      })
    );
  }
  adminInteractiveGetInteractiveReports(): __Observable<
    Array<InteractReportsEx>
  > {
    return this.adminInteractiveGetInteractiveReportsResponse().pipe(
      __map((_r) => _r.body as Array<InteractReportsEx>)
    );
  }

  /**
   * @param edit undefined
   */
  adminInteractiveEditInteractiveReportResponse(
    edit: InteractReports
  ): __Observable<__StrictHttpResponse<InteractReports>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = edit;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/EditInteractiveReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InteractReports>;
      })
    );
  }
  /**
   * @param edit undefined
   */
  adminInteractiveEditInteractiveReport(
    edit: InteractReports
  ): __Observable<InteractReports> {
    return this.adminInteractiveEditInteractiveReportResponse(edit).pipe(
      __map((_r) => _r.body as InteractReports)
    );
  }

  /**
   * @param interactReportId undefined
   */
  adminInteractiveDeleteInteractiveReportResponse(
    interactReportId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactReportId != null)
      __params = __params.set("interactReportId", interactReportId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/DeleteInteractiveReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param interactReportId undefined
   */
  adminInteractiveDeleteInteractiveReport(
    interactReportId?: number
  ): __Observable<Blob> {
    return this.adminInteractiveDeleteInteractiveReportResponse(
      interactReportId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param interactId undefined
   */
  adminInteractiveSendEmailNotificationsResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/interactive/AdminInteractive/SendEmailNotifications`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  adminInteractiveSendEmailNotifications(
    interactId?: number
  ): __Observable<Blob> {
    return this.adminInteractiveSendEmailNotificationsResponse(interactId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module AdminInteractiveService {
  /**
   * Parameters for AdminInteractiveCreateInteractive
   */
  export interface AdminInteractiveCreateInteractiveParams {
    upload?: null | Blob;
    interactiveUdPreFilteredInteractives?: null | Array<UdPreFilteredInteractives>;
    interactiveUdModInteractives?: null | Array<UdModInteractives>;
    interactiveUdInteractFilters?: null | Array<UdInteractFilters>;
    interactiveUdInteractBookemarks?: null | Array<UdInteractBookmarks>;
    interactiveSubInteractReportExports?: null | Array<SubInteractReportExports>;
    interactiveProductUrl?: null | string;
    interactivePreFilterTitleAvailable?: boolean;
    interactivePreFilterRegionAvailable?: boolean;
    interactivePreFilterOccupationAvailable?: boolean;
    interactivePreFilterKeys?: null | Array<PreFilterKeys>;
    interactivePreFilterIndustryAvailable?: boolean;
    interactivePreFilterCompanyAvailable?: boolean;
    interactivePowerBireportPublishDate?: null | string;
    interactivePowerBireportId?: null | string;
    interactivePowerBiobjectNames?: null | string;
    interactivePowerBidatasetPublishDate?: null | string;
    interactivePowerBidatasetId?: null | string;
    interactivePartnerEmbeds?: null | Array<PartnerEmbed>;
    interactiveMarketingUrl?: null | string;
    interactiveLogs?: null | Array<UserLog>;
    interactiveInteractSubContents?: null | Array<InteractSubContents>;
    interactiveInteractReports?: null | Array<InteractReports>;
    interactiveInteractName?: null | string;
    interactiveInteractId?: number;
    interactiveFreeInteractiveUrl?: null | string;
    interactiveFreeInteractive?: boolean;
    interactiveFileName?: null | string;
    interactiveFileId?: null | string;
    interactiveDescription?: null | string;
    interactiveCanPreFilter?: boolean;
    interactiveCanModify?: boolean;
  }

  /**
   * Parameters for AdminInteractiveEditInteractive
   */
  export interface AdminInteractiveEditInteractiveParams {
    upload?: null | Blob;
    interactiveUdPreFilteredInteractives?: null | Array<UdPreFilteredInteractives>;
    interactiveUdModInteractives?: null | Array<UdModInteractives>;
    interactiveUdInteractFilters?: null | Array<UdInteractFilters>;
    interactiveUdInteractBookemarks?: null | Array<UdInteractBookmarks>;
    interactiveSubInteractReportExports?: null | Array<SubInteractReportExports>;
    interactiveProductUrl?: null | string;
    interactivePreFilterTitleAvailable?: boolean;
    interactivePreFilterRegionAvailable?: boolean;
    interactivePreFilterOccupationAvailable?: boolean;
    interactivePreFilterKeys?: null | Array<PreFilterKeys>;
    interactivePreFilterIndustryAvailable?: boolean;
    interactivePreFilterCompanyAvailable?: boolean;
    interactivePowerBireportPublishDate?: null | string;
    interactivePowerBireportId?: null | string;
    interactivePowerBiobjectNames?: null | string;
    interactivePowerBidatasetPublishDate?: null | string;
    interactivePowerBidatasetId?: null | string;
    interactivePartnerEmbeds?: null | Array<PartnerEmbed>;
    interactiveMarketingUrl?: null | string;
    interactiveLogs?: null | Array<UserLog>;
    interactiveInteractSubContents?: null | Array<InteractSubContents>;
    interactiveInteractReports?: null | Array<InteractReports>;
    interactiveInteractName?: null | string;
    interactiveInteractId?: number;
    interactiveFreeInteractiveUrl?: null | string;
    interactiveFreeInteractive?: boolean;
    interactiveFileName?: null | string;
    interactiveFileId?: null | string;
    interactiveDescription?: null | string;
    interactiveCanPreFilter?: boolean;
    interactiveCanModify?: boolean;
  }
}

export { AdminInteractiveService };
